import { useTheme } from "@up/data";

import { useCart } from "./CartContext";

import type { ReactNode } from "react";

type LayoutProps = {
  children: ReactNode;
  currentStep?: number;
  headingClass: string;
};

const bulletClass =
  "flex items-center justify-center size-5 rounded-full text-sm text-white";

export const Layout = function Layout({
  children,
  currentStep,
  headingClass,
}: LayoutProps) {
  const theme = useTheme();
  const cart = useCart();

  return (
    <div className="up-container">
      <div className="checkout-layout mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8 pb-6 border-b border-gray-300">
          <h1 className={headingClass}>Enroll</h1>
          {currentStep != null ? (
            <nav>
              <ol className="flex items-center gap-6">
                <li className={currentStep === 0 ? "font-bold" : "opacity-60"}>
                  <button
                    disabled={currentStep === 0}
                    onClick={() => {
                      if (currentStep === 1) {
                        cart.navigateToStep(0);
                      }
                    }}
                    className={`flex items-center gap-2 bg-transparent border-none ${
                      currentStep === 1 ? "underline underline-offset-4" : ""
                    }`}
                  >
                    <div
                      className={bulletClass}
                      style={{
                        backgroundColor: theme.primaryColor,
                      }}
                    >
                      1
                    </div>
                    Review your order
                  </button>
                </li>
                <li className={currentStep === 1 ? "font-bold" : "opacity-60"}>
                  <div className="flex items-center gap-2">
                    <div
                      className={bulletClass}
                      style={{
                        backgroundColor: theme.primaryColor,
                      }}
                    >
                      2
                    </div>
                    Payment
                  </div>
                </li>
              </ol>
            </nav>
          ) : null}
        </div>
        {children}
      </div>
    </div>
  );
};
